import { Distribution } from "./models/Distribution";
import { Show } from "./models/Show";
import { Content } from "./models/Content";
import { User } from "../gtm/User";
import { Device } from "./models/Device";
import { Page } from "./models/Page";

type DataLayerProperties = {
  show?: Show;
  dist?: Distribution;
  content?: Content;
  user?: User;
  device?: Device;
  page?: Page;
};

export function getDataLayerProperties(): DataLayerProperties {
  const show = dataLayerHelper.get<Show>("show");
  const dist = dataLayerHelper.get<Distribution>("distribution");
  const content = dataLayerHelper.get<Content>("content");
  const user = dataLayerHelper.get<User>("user");
  const device = dataLayerHelper.get<Device>("device");
  const page = dataLayerHelper.get<Page>("page");

  return { show, dist, content, user, device, page };
}

export function getOttChannel(dist: Distribution | undefined): string {
  return dist?.channels?.ott?.principal === "ICI Radio-Canada"
    ? dist?.channels.ott?.additional ?? ""
    : dist?.channels?.ott?.principal ?? "";
}
